import { makeObservable, observable, action } from 'mobx'

import SharedStore from 'shared/stores/shared.store'

import {
  AccessibilityTemplateApi,
  createAccessibilityTemplateApi,
  AccessibilityTemplate,
} from '../api/accessibilityTemplates.api'

export class AccessibilityTemplatesV2Store extends SharedStore<AccessibilityTemplate> {
  storeName = 'AccessibilityTemplatesV2Store'
  declare childApi: AccessibilityTemplateApi

  constructor(root) {
    super()
    this.childApi = createAccessibilityTemplateApi(root.apiClient)
    makeObservable(this)
  }

  @observable accessibilityStatement = null
  @observable statementOptionPairs = []
  @observable options = []
  @observable categories = []

  @action
  async createAccessibilityStatement(): Promise<void> {
    const resp = await this.childApi.createAccessibilityStatement()
    if (resp.responseType === 'success') {
      this.accessibilityStatement = resp.data
      this.loading = false
    }
  }
  @action
  async deleteAccessibilityStatement(): Promise<void> {
    const resp = await this.childApi.deleteAccessibilityStatement()
    if (resp.responseType === 'success') {
      this.accessibilityStatement = resp.data
      this.loading = false
    }
  }

  @action
  async fetchStatementOptionPairs(): Promise<void> {
    const resp = await this.childApi.fetchStatementOptionPairs()
    if (resp.responseType === 'success') {
      this.statementOptionPairs = resp.data
      this.loading = false
    }
  }
  @action
  async createStatementOptionPair(data): Promise<void> {
    const resp = await this.childApi.createStatementOptionPair(data)
    if (resp.responseType === 'success') {
      this.statementOptionPairs = resp.data
      this.loading = false
    }
  }
  @action
  async updateStatementOptionPair(id, data): Promise<void> {
    const resp = await this.childApi.updateStatementOptionPair(id, data)
    if (resp.responseType === 'success') {
      this.statementOptionPairs = resp.data
      this.loading = false
    }
  }
  @action
  async deleteStatementOptionPair(id): Promise<void> {
    const resp = await this.childApi.deleteStatementOptionPair(id)
    if (resp.responseType === 'success') {
      this.statementOptionPairs = resp.data
      this.loading = false
    }
  }

  @action
  async fetchCategories(): Promise<void> {
    const resp = await this.childApi.fetchCategories()
    if (resp.responseType === 'success') {
      this.categories = resp.data
      this.loading = false
    }
  }
  async fetchOptions(): Promise<void> {
    const resp = await this.childApi.fetchOptions()
    if (resp.responseType === 'success') {
      this.options = resp.data
      this.loading = false
    }
  }
}
